module.exports = __webpack_public_path__ + "img/Icon-18.87c17457.png";